import { Component, OnInit, signal } from '@angular/core';
import { OrganizationSubscription } from '../organization-subscription';
import { SettingService } from '../setting.service';
import { UserRoleService } from '../user-role.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationUpdateSubscriptionComponent } from '../organization-update-subscription/organization-update-subscription.component';
import { FormatDateTimePipe } from '../format-date-time.pipe';
import { CommonModule, NgIf } from '@angular/common';

@Component({
  selector: 'app-settings-subscriptions-list',
  templateUrl: './settings-subscriptions-list.component.html',
  styleUrls: ['./settings-subscriptions-list.component.css'],
  imports: [NgIf, FormatDateTimePipe, CommonModule]
})
export class SettingsSubscriptionsListComponent implements OnInit {

  // Properties
  subscription: OrganizationSubscription;
  isSuperUser: boolean = false;
  isFranchiseOwner = signal<boolean>(false);
  isSubscriptionOpen = JSON.parse(sessionStorage.getItem('isSubOpen') || 'false');

  constructor(
    private settingService: SettingService,
    private userRoleService: UserRoleService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getOrganizationSubscription();
    this.initializeUserRoles();
  }

  private initializeUserRoles(): void {
    this.isSuperUser = this.userRoleService.isSuperUser();
    this.isFranchiseOwner.set(this.userRoleService.isFranchiseOwner());
  }

  // Get Organization Subscription
  private getOrganizationSubscription(): void {
    this.settingService.getOrganizationSubscription('STANDARD').subscribe((subscription) => {
      this.subscription = subscription;
      if(this.isSubscriptionOpen){
        this.openUpdateSubscriptionModal();
      }
    });
  }

  // Open Update Subscription Modal
  openUpdateSubscriptionModal() {
    if(this.isFranchiseOwner()) {
      return;
    }
    const modalReference = this.modalService.open(OrganizationUpdateSubscriptionComponent);
    modalReference.componentInstance.selectedSubscription = this.subscription;
    modalReference.componentInstance.saved.subscribe(() => {
       localStorage.removeItem('isSubOpen');
      this.getOrganizationSubscription();
    });

    
    modalReference.closed.subscribe((result) => {
     localStorage.removeItem('isSubOpen');
    });

   
    modalReference.dismissed.subscribe((reason) => {
      localStorage.removeItem('isSubOpen');
    });
  }

  // Open Modal Alert
  // openModalAlert() {
  //   let ngbModalOptions: NgbModalOptions = {
  //     backdrop: 'static',
  //     keyboard: false,
  //     size: 'sm'
  //   };
  //   const modalReference = this.modalService.open(SubscriptionAlertModalComponent, ngbModalOptions);
  //   modalReference.componentInstance.type = "Success";
  //   modalReference.componentInstance.message = "You have successfully updated your subscription! We need to log you out in order for the application to get the latest details.";
  //   modalReference.closed.subscribe(data => {
  //     this.authService.logout();
  //   });
  // }

  // Open Cancel Subscription Modal
  // openCancelSubscriptionModal() {
  //   const modalReference = this.modalService.open(CancelSubscriptionAlertModalComponent, { size: 'lg' });
  //   modalReference.componentInstance.okay.subscribe((cancelEvent: CancelSubscription) => {
  //     this.settingService.cancelSubscription(cancelEvent).subscribe(() => {
  //       this.openCancelAlert();
  //     });
  //   })
  // }

  // Open Cancel Alert
  // openCancelAlert() {
  //   let ngbModalOptions: NgbModalOptions = {
  //     backdrop: 'static',
  //     keyboard: false,
  //     size: 'sm'
  //   };
  //   const modalReference = this.modalService.open(SubscriptionAlertModalComponent, ngbModalOptions);
  //   modalReference.componentInstance.type = "Success";
  //   modalReference.componentInstance.message = "You have successfully canceled your subscription! We need to log you out.";
  //   modalReference.closed.subscribe(data => {
  //     this.authService.logout();
  //   })
  // }

  // Get Price
  getPrice(price: number): number {
    return Number.isInteger(price) ? price : +price?.toFixed(2);
  }
}
